<sh-control *ngIf="control" [control]="this">
  <p-dropdown
    class="w-100"
    [id]="id ?? ''"
    [ngModel]="inputValue"
    (ngModelChange)="inputValue = $event"
    (onBlur)="markTouched()"
    [options]="options"
    [optionLabel]="optionLabel ?? ''"
    [optionValue]="primeOptionValue"
    [filter]="filter"
    [filterBy]="filterBy ?? optionLabel ?? ''"
    [showClear]="showClearButton"
    [disabled]="disabled"
    [placeholder]="placeholder ?? ('shared.terms.select' | translate) + '...'"
    [appendTo]="appendTo"
    [editable]="editable"
    (onFilter)="emitFilter($event)"
  >
    <ng-template pTemplate="item" let-option>
      <ng-container
        *ngIf="itemTemplate; else defaultItem"
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{ $implicit: option }"
      ></ng-container>

      <ng-template #defaultItem>
        {{ option?.[optionLabel || ''] }}
      </ng-template>
    </ng-template>

    <ng-template pTemplate="selectedItem" let-option>
      <ng-container
        *ngIf="selectedItemTemplate; else defaultSelected"
        [ngTemplateOutlet]="selectedItemTemplate"
        [ngTemplateOutletContext]="{ $implicit: option }"
      ></ng-container>

      <ng-template #defaultSelected>
        {{ option?.[optionLabel || ''] }}
      </ng-template>
    </ng-template>
  </p-dropdown>
</sh-control>
